// extracted by mini-css-extract-plugin
export default {"container":"styles_container__p4u1K","container__user_info":"styles_container__user_info__LPiqy","container__back":"styles_container__back__-Jjvb"};